import { Box, Typography } from '@mui/material'
import { FC } from 'react'

// others
import { images } from '../../../assets/images'
import { flexCenter, flexJustifySpaceBetween } from '../../../theme/styleConstants'

const BillViewHeader: FC = () => {
  return (
    <Box
      sx={{
        ...flexCenter,
        ...flexJustifySpaceBetween,
        px: { xs: 2, md: 6 },
        py: 1,
        backgroundColor: primary => primary.palette.common.white
      }}
    >
      <Box component="img" src={images.LOGO} alt="Helmer Legal Logo" sx={{ maxWidth: 95, maxHeight: 46 }} />

      <Typography variant="h6" fontWeight={600}>
        BILL
      </Typography>
    </Box>
  )
}

export default BillViewHeader
